export default __webpack_public_path__ + "static/media/cloud-version.04084229.svg";